//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DocumentTemplateRuleClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetSingleDocumentTemplateRuleQueryParameters = {
  id: number ;
}

export type PatchDocumentTemplateRuleQueryParameters = {
  id: number ;
}

export type RemoveDocumentTemplateRuleQueryParameters = {
  id: number ;
}

export type GetDocumentTemplateRuleQueryParameters = {
  subtenantId?: number | null | undefined ;
}

export function getSingleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/document-template-rules/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSingleDefaultOptions: Omit<UseQueryOptions<Types.DocumentTemplateRuleDto, unknown, Types.DocumentTemplateRuleDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DocumentTemplateRuleDto, unknown, Types.DocumentTemplateRuleDto>, 'queryFn'>> = {
};
export function getGetSingleDefaultOptions() {
  return getSingleDefaultOptions;
};
export function setGetSingleDefaultOptions(options: typeof getSingleDefaultOptions) {
  getSingleDefaultOptions = options;
}

export function getSingleQueryKey(id: number): QueryKey;
export function getSingleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetSingleDocumentTemplateRuleQueryParameters;

    return trimArrayEnd([
        'DocumentTemplateRuleClient',
        'getSingle',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DocumentTemplateRuleClient',
        'getSingle',
        ...params
      ]);
  }
}
export function __getSingle(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSingle(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSingleQuery<TSelectData = Types.DocumentTemplateRuleDto, TError = unknown>(dto: GetSingleDocumentTemplateRuleQueryParameters, options?: Omit<UseQueryOptions<Types.DocumentTemplateRuleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetSingleQuery<TSelectData = Types.DocumentTemplateRuleDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.DocumentTemplateRuleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSingleQuery<TSelectData = Types.DocumentTemplateRuleDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DocumentTemplateRuleDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetSingleDocumentTemplateRuleQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DocumentTemplateRuleDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSingle(context, axiosConfig) : __getSingle,
    queryKey: getSingleQueryKey(id),
    ...getSingleDefaultOptions as unknown as Omit<UseQueryOptions<Types.DocumentTemplateRuleDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetSingleData(queryClient: QueryClient, updater: (data: Types.DocumentTemplateRuleDto | undefined) => Types.DocumentTemplateRuleDto, id: number) {
  queryClient.setQueryData(getSingleQueryKey(id),
    updater
  );
}

export function setGetSingleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DocumentTemplateRuleDto | undefined) => Types.DocumentTemplateRuleDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/document-template-rules/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DocumentTemplateRuleClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DocumentTemplateRuleDto, unknown, Types.PatchTemplateRuleDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DocumentTemplateRuleDto, unknown, Types.PatchTemplateRuleDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchTemplateRuleDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchDocumentTemplateRuleQueryParameters & {
  dto: Types.PatchTemplateRuleDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DocumentTemplateRuleDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchDocumentTemplateRuleQueryParameters}): UseMutationResult<Types.DocumentTemplateRuleDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/document-template-rules/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DocumentTemplateRuleClient',
      'remove',
      id as any,
    ]);
}

export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveDocumentTemplateRuleQueryParameters

export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveDocumentTemplateRuleQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getUrl(subtenantId?: number | null | undefined): string {
  let url_ = getBaseUrl() + "/api/document-template-rules?";
if (subtenantId !== undefined && subtenantId !== null)
    url_ += "SubtenantId=" + encodeURIComponent("" + subtenantId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.DocumentTemplateRuleListDto[], unknown, Types.DocumentTemplateRuleListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DocumentTemplateRuleListDto[], unknown, Types.DocumentTemplateRuleListDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(subtenantId?: number | null | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { subtenantId,  } = params[0] as GetDocumentTemplateRuleQueryParameters;

    return trimArrayEnd([
        'DocumentTemplateRuleClient',
        'get',
        subtenantId as any,
      ]);
  } else {
    return trimArrayEnd([
        'DocumentTemplateRuleClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number | null | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.DocumentTemplateRuleListDto[], TError = unknown>(dto: GetDocumentTemplateRuleQueryParameters, options?: Omit<UseQueryOptions<Types.DocumentTemplateRuleListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.DocumentTemplateRuleListDto[], TError = unknown>(subtenantId?: number | null | undefined, options?: Omit<UseQueryOptions<Types.DocumentTemplateRuleListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.DocumentTemplateRuleListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DocumentTemplateRuleListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let subtenantId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ subtenantId,  } = params[0] as GetDocumentTemplateRuleQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [subtenantId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DocumentTemplateRuleListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(subtenantId),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.DocumentTemplateRuleListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.DocumentTemplateRuleListDto[] | undefined) => Types.DocumentTemplateRuleListDto[], subtenantId?: number | null | undefined) {
  queryClient.setQueryData(getQueryKey(subtenantId),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DocumentTemplateRuleListDto[] | undefined) => Types.DocumentTemplateRuleListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/document-template-rules";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'DocumentTemplateRuleClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.DocumentTemplateRuleDto, unknown, Types.CreateTemplateRuleDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DocumentTemplateRuleDto, unknown, Types.CreateTemplateRuleDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateTemplateRuleDto) => Client.create(dto),
    mutationKey: key,
  });
}